import { INSTRUMENT } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import InstrumentPage from "./container/InstrumentPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: INSTRUMENT,
    withSidebar: true,
    withAppBar: true,
    component: InstrumentPage,
  };
}
